export default function StatsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[60%]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
              Why Thousands of Shoppers Trust
              <br />
              <span className="text-primary-500">Hipobuy Spreadsheet</span> Resources
            </h2>

            <div className="grid grid-cols-3 gap-4 md:gap-6 mb-8">
              <div className="border-r border-background-200/60 pr-4 md:pr-6">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">250+</div>
                <p className="text-sm text-foreground-600 mt-1">SEO Shopping Guides</p>
              </div>
              <div className="border-r border-background-200/60 pr-4 md:pr-6">
                <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">14</div>
                <p className="text-sm text-foreground-600 mt-1">Product Categories</p>
              </div>
              <div className="pr-0">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">40K+</div>
                <p className="text-sm text-foreground-600 mt-1">Organized Product Finds</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-time-line', title: 'Save Research Time', desc: 'Organized databases cut hours of manual searching down to minutes.' },
                { icon: 'ri-fire-line', title: 'Find Trending Products', desc: 'Stay ahead with regularly updated trending product collections.' },
                { icon: 'ri-scales-3-line', title: 'Compare Options Easily', desc: 'Side-by-side comparisons help you make informed decisions fast.' },
                { icon: 'ri-lightbulb-line', title: 'Discover New Categories', desc: 'Explore categories and products you never knew existed.' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-background-50 border border-background-200/40">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-accent-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm mb-1">{item.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[40%] w-full">
            <div className="relative h-[400px] md:h-[500px] rounded-2xl overflow-hidden bg-background-200/50">
              <div className="grid grid-cols-2 gap-2 p-2 h-full">
                <div className="rounded-xl overflow-hidden h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Fashion%20designer%20sneakers%20collection%20collage%20on%20minimal%20warm%20cream%20background%2C%20luxury%20product%20photography%20moodboard%20style%2C%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=400&height=500&seq=stats-collage-sneakers-v2&orientation=portrait"
                    alt="Sneakers collage"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="grid grid-rows-2 gap-2 h-full">
                  <div className="rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Premium%20streetwear%20hoodies%20and%20jackets%20collection%20display%20on%20minimal%20warm%20beige%20background%2C%20fashion%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20soft%20editorial%20lighting&width=400&height=250&seq=stats-collage-streetwear-v2&orientation=portrait"
                      alt="Streetwear collage"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Luxury%20accessories%20bags%20watches%20belts%20flatlay%20on%20minimal%20warm%20white%20background%2C%20fashion%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20clean%20editorial%20style&width=400&height=250&seq=stats-collage-access-v2&orientation=portrait"
                      alt="Accessories collage"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}